import React from "react";
import { FaEnvelope, FaPhone, FaWhatsapp } from "react-icons/fa";
import EatEzyLogo from "./EatEzyLogo";

export default function LandingFooter() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <div className="mb-6">
            <EatEzyLogo size="default" className="text-white" showTagline={false} />
          </div>
          <p className="text-gray-300 text-lg leading-relaxed max-w-xl mb-8">
            The leading SaaS platform for digital menus and WhatsApp ordering.
            <br className="hidden sm:inline" />
            <span className="text-white/90">Transform your restaurant operations</span> with our cloud-based solution.
          </p>
          <div className="flex items-center justify-center gap-4">
            <a
              href="mailto:info@yorotechnologies.com"
              className="flex items-center justify-center w-12 h-12 rounded-full border border-white/20 text-gray-300 hover:text-white hover:border-teal-400/50 hover:bg-white/10 transition-all duration-300 flex-shrink-0"
              title="Email us"
            >
              <FaEnvelope className="w-5 h-5" />
            </a>
            <a
              href="tel:+919207600660"
              className="flex items-center justify-center w-12 h-12 rounded-full border border-white/20 text-gray-300 hover:text-white hover:border-teal-400/50 hover:bg-white/10 transition-all duration-300 flex-shrink-0"
              title="Call +91 9207600660"
            >
              <span style={{ display: "inline-block", transform: "rotate(90deg)" }}>
                <FaPhone className="w-5 h-5" />
              </span>
            </a>
            <a
              href="https://wa.me/919207600660"
              className="flex items-center justify-center w-12 h-12 rounded-full border border-white/20 text-gray-300 hover:text-white hover:border-teal-400/50 hover:bg-white/10 transition-all duration-300 flex-shrink-0"
              title="WhatsApp +91 9207600660"
            >
              <FaWhatsapp className="w-5 h-5" />
            </a>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © 2026 EatEzy. All rights reserved. Digital Menu & WhatsApp Ordering SaaS Platform.
          </p>
        </div>
      </div>
    </footer>
  );
}

